module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "aso-token-step"
  }, [_c('h2', {
    staticClass: "aso-token-step__title"
  }, [_vm._v("Digite o código que enviamos por e-mail.")]), _vm._v(" "), _c('p', {
    staticClass: "aso-token-step__text"
  }, [_vm._v("\n    Ele foi enviado para "), _c('strong', [_vm._v(_vm._s(_vm.email))]), _vm._v(". Se não o encontrar, confira sua caixa de spam ou\n    "), _c('button', {
    staticClass: "aso-token-step__link",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": function($event) {
        return _vm.$emit('change-email')
      }
    }
  }, [_vm._v("\n      altere seu e-mail\n    ")]), _vm._v(".\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "aso-token-step__grid"
  }, _vm._l((_vm.values), function(value, index) {
    return _c('input', {
      key: index,
      ref: 'tokenDigit' + index,
      refInFor: true,
      staticClass: "aso-token-step__digit",
      attrs: {
        "data-token-index": index,
        "data-token-type": "email",
        "type": "text",
        "inputmode": "numeric",
        "pattern": "[0-9]*",
        "maxlength": "1",
        "disabled": _vm.busy
      },
      domProps: {
        "value": value
      },
      on: {
        "input": function($event) {
          return _vm.$emit('digit-input', {
            index: index,
            value: $event.target.value
          })
        },
        "keydown": [function($event) {
          return _vm.$emit('digit-keydown', {
            index: index,
            key: $event.key
          })
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.canConfirm && _vm.$emit('confirm')
        }],
        "paste": function($event) {
          index === 0 ? _vm.$emit('paste', $event) : null
        }
      }
    })
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "aso-token-step__confirm aso-flow-button aso-flow-button--loud aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.canConfirm
    },
    on: {
      "click": function($event) {
        return _vm.$emit('confirm')
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.busy ? 'Validando...' : 'Confirmar Código') + "\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "aso-token-step__resend aso-flow-button aso-flow-button--quiet aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.canResend
    },
    on: {
      "click": function($event) {
        return _vm.$emit('resend')
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.resendLabel) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b12d0cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/funcionario/aso/assinar/AsoValidaTokenEmailStep.vue
// module id = 1495
// module chunks = 45